import { NgIf } from '@angular/common';
import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { Customer } from '@df/session/api/customer';
import { Subscription } from 'rxjs';
import { LocalCustomerModel } from '../../customer/customer.model.decorator';

/**
 * Use this directive to present element only when app is in standalone mode AND user has loyaltyId
 *
 * ```html
 * <div *ifAppCustomer>...</div>
 * ```
 */
@Directive({
    selector: '[ifAppCustomer]',
    standalone: true
})
export class IfAppCustomerDirective extends NgIf implements OnInit, OnDestroy {
    protected pwaIntegrationService = inject(PwaIntegrationService);
    protected customer = inject(Customer);
    private subscription = new Subscription();

    ngOnInit() {
        this.updateCondition();

        // Subscribe to customer data changes
        this.subscription.add(
            this.customer.model.obs.data.subscribe(() => {
                this.updateCondition();
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    protected updateCondition() {
        const isStandalone = this.pwaIntegrationService.isStandalone;
        const customerModel = this.customer.model as LocalCustomerModel;
        const hasLoyaltyId = !!customerModel?.loyaltyId;

        this.ngIf = isStandalone && hasLoyaltyId;
    }
}
